// Client-side mirror of webhook-server's Digest::SubjectRenderer.render_template
// (sc-6504), used only for the live preview in DigestSettingsDialog. The server
// is authoritative; webhook-server/test/fixtures/files/digest_subject_cases.json
// is asserted by both sides so the two can't drift.

export const MAX_SUBJECT_LENGTH = 200;

// Exact lower-case token names only. Spaced or upper-case forms, ERB, and
// `#{}` stay literal — the template is never evaluated.
const EXACT_TOKEN = /\{\{([a-z_]+)\}\}/g;

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** Same format as Ruby's `strftime('%B %d, %Y')` — zero-padded day. */
export const formatDigestDate = (date: Date): string =>
  `${MONTHS[date.getMonth()]} ${String(date.getDate()).padStart(2, '0')}, ${date.getFullYear()}`;

/** Fixed sample values the preview renders against. */
export const sampleTokenValues = (today: Date = new Date()): Record<string, string> => ({
  location_name: 'Acme Branch 12',
  organization_name: 'Acme Supply',
  digest_date: formatDigestDate(today),
  restock_count: '3',
  oos_count: '1',
});

export function renderSubjectPreview(template: string, values: Record<string, string>): string {
  // Single pass: a value that itself contains `{{…}}` is not re-expanded.
  const out = template.replace(EXACT_TOKEN, (match, name: string) =>
    Object.prototype.hasOwnProperty.call(values, name) ? values[name] : match,
  );
  // Count code points like Ruby's String#truncate, not UTF-16 units.
  const chars = Array.from(out);
  return chars.length > MAX_SUBJECT_LENGTH ? `${chars.slice(0, MAX_SUBJECT_LENGTH - 1).join('')}…` : out;
}
